<template>
    <div id="app">
        <alert></alert>        
        <v-app>
            <v-toolbar v-if="isAuthenticated" app :clipped-left="clipped" color="light-blue" dark>
                <img src="@/assets/logo.png" alt="logo" class="logo pointer" @click="goToDashboard()">
                <v-list class="top-menu-list">
                    <v-list-tile>
                        <span v-if="adminLoggedIn()" class="pointer"  v-for="(item, i) in adminMenuItems" :key="i" v-bind:class="{ active: (getCurrentRouteName() == item.routeName) }" @click="goToPath(item.path)">{{item.title}}</span>
                        <span v-if="managerLoggedIn()" class="pointer"  v-for="(item, i) in managerMenuItems" :key="i" v-bind:class="{ active: (getCurrentRouteName() == item.routeName) }" @click="goToPath(item.path)">{{item.title}}</span>
                        <span v-if="authorLoggedIn()" class="pointer"  v-for="(item, i) in authorMenuItems" :key="i" v-bind:class="{ active: (getCurrentRouteName() == item.routeName) }" @click="goToPath(item.path)">{{item.title}}</span>
                        <span v-if="memberLoggedIn()" class="pointer"  v-for="(item, i) in memberMenuItems" :key="i" v-bind:class="{ active: (getCurrentRouteName() == item.routeName) }" @click="goToPath(item.path)">{{item.title}}</span>
                    </v-list-tile>
                    <v-toolbar-title :right="right"></v-toolbar-title>
                </v-list>
                <v-btn v-if="!memberLoggedIn()" depressed color="success" @click="goToAddRecipe()" v-text="addRecipe">Add Recipe</v-btn>
                <v-btn depressed primary @click="logoutFunc()" v-text="logout" active-class>Logout</v-btn>
            </v-toolbar>
            <v-content id="app-content">
                <v-content>
                    <router-view :key="$route.fullPath"></router-view>
                   <!-- <div v-if="!isAuthenticated" class="cta-share text-center pointer">
                        <v-btn color="info" large @click="goToPath('/contribute')">Share Recipes</v-btn>
                    </div>         -->
                    <div class="bottom-menu-link text-center pointer">            
                        <span @click="goToPath('/terms')">Terms</span>&nbsp;-&nbsp;                        
                        <span @click="goToPath('/privacy')">Privacy</span>&nbsp;-&nbsp;
                        <span @click="goToPath('/support')">Support</span>
                        <span v-if="!isAuthenticated" @click="goToPath('login')">&nbsp;-&nbsp;Login</span>
                        <!-- <span v-if="!isAuthenticated" @click="goToPath('signup')">&nbsp;-&nbsp;Signup</span> -->
                    </div>
                    <div class="copyright text-center">
                        Copyright McKeever Consulting, LLC 2018, All rights reserved.
                    </div>                    
                </v-content>
            </v-content>
        </v-app>        
    </div>
</template>

<script>
    import Alert from "./components/common/Alert.vue";
    import UserService from "@/services/db/UserService.js";
    import CONSTANT from "@/services/Constant.js";

    export default {
        name: "app",
        components: {
            alert: Alert
        },
        data() {
            return {
                clipped: true,
                drawer: false,
                fixed: false,
                miniVariant: false,
                right: true,
                rightDrawer: false,
                title: 'Meal Planner Web',
                logout: 'Logout',
                addRecipe: 'Add Recipe',
                loginPath: '/'
            };
        },
        created() { 
        },
        computed: {
            /*
            * Method to check that request is authenticated or not
            */
            currentUser() {
                var _USER = JSON.parse(this.$store.getters.loginUser);
                return _USER;
            },
            
            /*
            * Method to check that request is authenticated or not
            */
            isAuthenticated() {
                return this.$store.getters.isAuthenticated;
            },

            /*
            * Method to add menu rolewise
            */
            adminMenuItems() {
                var _items = [];

                _items.push({
                    icon: "account_box",
                    path: "/recipes",
                    title: "Recipes",
                    routeName: "Recipes",
                    subMenus: [],
                    sequence: 1
                });

                _items.push({
                    icon: "account_box",
                    path: "/profile",
                    title: "Profile",
                    routeName: "Profile",
                    subMenus: [],
                    sequence: 1
                });
                return _items;
            },

            managerMenuItems() {
                var _items = [];

                _items.push({
                    icon: "account_box",
                    path: "/recipes",
                    title: "Recipes",
                    routeName: "Recipes",
                    subMenus: [],
                    sequence: 1
                });

                _items.push({
                    icon: "account_box",
                    path: "/profile",
                    title: "Profile",
                    routeName: "Profile",
                    subMenus: [],
                    sequence: 1
                });
                return _items;
            },
            
            authorMenuItems() {
                var _items = [];

                _items.push({
                    icon: "account_box",
                    path: "/recipes",
                    title: "Recipes",
                    routeName: "Recipes",
                    subMenus: [],
                    sequence: 1
                });

                _items.push({
                    icon: "account_box",
                    path: "/profile",
                    title: "Profile",
                    routeName: "Profile",
                    subMenus: [],
                    sequence: 1
                });
                return _items;
            },

            memberMenuItems() {
                var _items = [];

                _items.push({
                    icon: "account_box",
                    path: "/newsfeed",
                    title: "News",
                    routeName: "Newsfeed",
                    subMenus: [],
                    sequence: 1
                });     
               
                _items.push({
                    icon: "account_box",
                    path: "/members",
                    title: "Members",
                    routeName: "MembersList",
                    subMenus: [],
                    sequence: 1
                });               

                _items.push({
                    icon: "account_box",
                    path: "/events",
                    title: "Events",
                    routeName: "EventsList",
                    subMenus: [],
                    sequence: 1
                });

                _items.push({
                    icon: "account_box",
                    path: "/discussions",
                    title: "Discussions",
                    routeName: "DiscussionsList",
                    subMenus: [],
                    sequence: 1
                });

                _items.push({
                    icon: "account_box",
                    path: "/recipebox",
                    title: "Recipebox",
                    routeName: "RecipeboxList",
                    subMenus: [],
                    sequence: 1
                }); 

                _items.push({
                    icon: "account_box",
                    path: "/stories",
                    title: "Stories",
                    routeName: "StoriesList",
                    subMenus: [],
                    sequence: 1
                });                
                
                _items.push({
                    icon: "account_box",
                    path: "/videos",
                    title: "Videos",
                    routeName: "VideosList",
                    subMenus: [],
                    sequence: 1
                });  
                
                _items.push({
                    icon: "account_box",
                    path: "/podcasts",
                    title: "Podcasts",
                    routeName: "PodcastsList",
                    subMenus: [],
                    sequence: 1
                });                 
                                
                _items.push({
                    icon: "account_box",
                    path: "/books",
                    title: "Books",
                    routeName: "BooksList",
                    subMenus: [],
                    sequence: 1
                });

                _items.push({
                    icon: "account_box",
                    path: "/members-detail/" + this.getCurrentUserId(),
                    title: "Profile",
                    routeName: "MemberProfile",
                    subMenus: [],
                    sequence: 1
                });                
                
                _items.push({
                    icon: "account_box",
                    path: "/subscription",
                    title: "Subscription",
                    routeName: "Subscription",
                    subMenus: [],
                    sequence: 1
                });                

                return _items;
            }            
        },

        methods: {
            /*
            * Method to check that request is authenticated or not
            */
            adminLoggedIn() {
                return (this.getCurrentUserRole() == CONSTANT.ROLES.ADMIN)? true : false;
            },
            managerLoggedIn() {
                return (this.getCurrentUserRole() == CONSTANT.ROLES.MANAGER)? true : false;
            },
            authorLoggedIn() {
                return (this.getCurrentUserRole() == CONSTANT.ROLES.AUTHOR)? true : false;
            },
            memberLoggedIn() {
                return (this.getCurrentUserRole() == CONSTANT.ROLES.BASIC_MEMBER || this.getCurrentUserRole() == CONSTANT.ROLES.PRO_MEMBER)? true : false;
            },
            getCurrentRouteName() {
                return this.$router.currentRoute.name;
            },
            getCurrentUserRole(){
                var _USER = JSON.parse(this.$store.getters.loginUser);
                return _USER['role'];
            },
            getCurrentUserId(){
                var _USER = JSON.parse(this.$store.getters.loginUser);
                return _USER['userId'];
            },

            /*
            * Method to logout and remove storage from local storage and redirect to login page
            */
            logoutFunc() {
                UserService.firebaseSignOut()
                .then(() => {
                    this.$store.commit("setAlert", {
                        isAlertSuccess: true,
                        message: CONSTANT.MESSAGES.USER.LOGOUT_SUCCESS
                    });
                    setTimeout(() => {
                        localStorage.removeItem("token");
                        localStorage.removeItem("mealLoginUser");
                        location.href = '/login';
                        window.location.reload();
                    }, 1000);
                })
                .catch(() => {
                    this.$store.commit("setAlert", {
                        isAlertError: true,
                        message: CONSTANT.MESSAGES.USER.LOGOUT_FAIL
                    });
                });
            },

            /*
            * Method to redirect specific path
            */
            goToPath(path) {
                this.$router.push(path);
            },

            /*
             * Method to redirect to add recipe page
             */
            goToAddRecipe() {
                this.$router.push("/addRecipe");
            },

            /*
             * Method to redirect to dashboard based on user role
             */
            goToDashboard(){
                var _role = this.getCurrentUserRole();
                var _route = (_role == CONSTANT.ROLES.ADMIN)? 'admin-dashboard' : (_role == CONSTANT.ROLES.MANAGER)? 'manager-dashboard' : (_role == CONSTANT.ROLES.AUTHOR)? 'author-dashboard' : 'member-dashboard';
                this.$router.push(_route);
            }
        }
    };
</script>


<style>
    .logo {
        height: 25px;
    }
    .sub-menu {
        padding-left: 50px;
    }
    .top-menu-list {
        background: transparent !important;
    }
    .top-menu-list div {
        height: 20px !important;
        display: inline;
    }
    .top-menu-list div span {
        margin-right: 15px;
        padding: 10px;
        font-size: 15px;
    }
    .top-menu-list div span.active {
        color: #333;
        border: 2px solid #333;
        padding: 10px;
        border-radius: 5px;
        font-weight: bold;
    }
    .copyright {
        margin: auto;
        font-size: 11px;
        color: #333;
        padding-top: 10px;
    } 
    .bottom-menu-link {
        margin: auto;
        margin-top: 0px;
        margin-bottom: 20px;        
        padding-top: 0px;
        font-size: 16px;
        color: #fff;
    }
    .cta-share {
        margin: auto;
        font-size: 24px;
        margin-bottom: 30px;
    }

    @media (min-width: 0px) and (max-width: 767px) {
        /* .top-menu-list {
            display: none;
        } */
        top-menu-list div span {
            margin-right: 10px;
            font-size: 12px;
        }
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .top-menu-list div span {
            margin-right: 10px;
            font-size: 12px;
        }
    }
</style>



